"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.labels = exports.isNotAcceptableLabelSponsor = exports.getLabel = exports.initLabelSet = void 0;
var labelTypes = __importStar(require("./labelTypes"));
var unacceptableLabelSponsors = __importStar(require("./unacceptableLabelSponsors"));
var defaultLabels_1 = require("./labelSets/defaultLabels");
var bmwLabels_1 = require("./labelSets/bmwLabels");
var acuraLabels_1 = require("./labelSets/acuraLabels");
var subaruLabels_1 = require("./labelSets/subaruLabels");
var subaruNewEnglandLabels_1 = require("./labelSets/subaruNewEnglandLabels");
var hondaLabels_1 = require("./labelSets/hondaLabels");
var toyotaLabels_1 = require("./labelSets/toyotaLabels");
var toyotaNewJerseyLabels_1 = require("./labelSets/toyotaNewJerseyLabels");
var lexusLabels_1 = require("./labelSets/lexusLabels");
var labelSets = {
    acura: acuraLabels_1.acuraLabels,
    bmw: bmwLabels_1.bmwLabels,
    subaru: subaruLabels_1.subaruLabels,
    subaruNewEngland: subaruNewEnglandLabels_1.subaruNewEnglandLabels,
    honda: hondaLabels_1.hondaLabels,
    toyota: toyotaLabels_1.toyotaLabels,
    toyotaNewJersey: toyotaNewJerseyLabels_1.toyotaNewJerseyLabels,
    lexus: lexusLabels_1.lexusLabels
};
var selectedLabelSet = defaultLabels_1.defaultLabels;
var initLabelSet = function (labelSetName) {
    if (labelSetName) {
        selectedLabelSet = mergeLabelSets(defaultLabels_1.defaultLabels, labelSets[labelSetName]);
    }
    else {
        selectedLabelSet = defaultLabels_1.defaultLabels;
    }
};
exports.initLabelSet = initLabelSet;
var getLabel = function (labelName) {
    return selectedLabelSet[labelName];
};
exports.getLabel = getLabel;
var isNotAcceptableLabelSponsor = function (sponsor) {
    return !!sponsor && sponsor.toLowerCase() === unacceptableLabelSponsors.KKB;
};
exports.isNotAcceptableLabelSponsor = isNotAcceptableLabelSponsor;
exports.labels = __assign({ initLabelSet: exports.initLabelSet, getLabel: exports.getLabel, isNotAcceptableLabelSponsor: exports.isNotAcceptableLabelSponsor }, labelTypes);
var mergeLabelSets = function (defaultSet, customSet) {
    var mergedLabels = __assign(__assign({}, defaultSet), customSet);
    return mergedLabels;
};
